import {combineReducers} from "redux";
import papers from "./papers";
import sessions from "./sessions";
import calendar from "./calendar";
import auth from "./auth";
import {connectRouter} from 'connected-react-router'

const createRootReducer = (history) => combineReducers({
    router: connectRouter(history),
    papers,
    sessions,
    calendar,
    auth
});

export default createRootReducer
